// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__title .text__inner[data-v-037e675e]{margin:0;font-size:68px;font-weight:400;line-height:1.09;letter-spacing:normal}.text__title .text__inner.bold[data-v-037e675e]{font-weight:700}", ""]);
// Exports
module.exports = exports;
